define('page/product-help', [
    'utils/toast',
    'utils/dom',
], function (toast, dom) {
    'use strict';
     
    //顶部搜索
    var input = document.querySelector('#inputSearch')
    var btn = document.querySelector('#btnSearch')

    if (btn && input) {
        btn.addEventListener('click', function () {
            var val = input.value

            if (val == '') return toast.show('搜索内容不能为空')

            var url = "/wiki"
            url += '?search=' + val
            window.location.href = url
        })
    }
});
